import { createContext, useContext } from "react";
const HttpClientContext = createContext(
  void 0
);
function useHttpClient() {
  const context = useContext(HttpClientContext);
  if (context === void 0) {
    throw new Error("useHttpClient must be used within a HttpClientProvider");
  }
  return context;
}
export {
  HttpClientContext,
  useHttpClient
};
//# sourceMappingURL=http-client-context.js.map
